import { Grid } from '@mui/material';
import { ButtonActionNew } from 'Components/ButtonActionNew';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { equipmentIcon1, equipmentIcon2, equipmentIcon3 } from 'Images';
import { useNavigate } from 'react-router-dom';
import { goToRequestNewEquipment } from 'Utils';

export const ButtonActions = () => {
  const isDesktop = useIsDesktop();
  const navigate = useNavigate();
  const dictionary = useDictionary(Dictionary, DICTIONARY.Equipment);

  return (
    <Grid
      justifyContent={isDesktop ? 'flex-start' : 'space-between'}
      container
      alignItems='center'
      spacing={isDesktop ? 3 : 1.5}
      mt={2}
      mb={2}
      flexWrap={'nowrap'}
    >
      <Grid item>
        <ButtonActionNew
          imageSrc={equipmentIcon1}
          text={dictionary.orderEquipment}
          callback={() => navigate('/Equipment/createOrder')}
          role='button'
        />
      </Grid>
      <Grid item>
        <ButtonActionNew
          imageSrc={equipmentIcon2}
          text={dictionary.requestEligibilityForNewEquiupment}
          callback={() => navigate('/universalRequest/1/2/39')}
          role='button'
        />
      </Grid>
      <Grid item>
        <ButtonActionNew
          imageSrc={equipmentIcon3}
          text={dictionary.requestRefund}
          callback={() =>
            (window.location.href =
              process.env.REACT_APP_REDIRECT_URL + 'universalRequest/1/2/98')
          }
          role='link'
        />
      </Grid>
    </Grid>
  );
};
